<template>
  <div>
    <ReactWrapper
      :component="component"
      v-bind="$props"
      @onChange="handleChange"
    />
  </div>
</template>

<script>
import { ReactWrapper } from "vuera"
/* react component. Doc here: https://reactdatepicker.com/ */
import DatePicker from "react-datepicker"

export default {
  components: {
    ReactWrapper,
  },
  props: {
    /* these props will be passed on to the react-date-picker component
    feel free to add new props as required, make sure to make it not
    required with default value so that old components work as before */
    showTimeSelect: {
      type: Boolean,
      required: false,
      default: true,
    },
    selected: {
      default: null,
    },
    dateFormat: {
      default: "MMM d, yyyy h:mm aa",
    },
    placeholderText: {
      default: "Select date",
    },
    showDisabledMonthNavigation: {
      type: Boolean,
    },
    minDate: {
      type: Date,
    },
    minTime: {
      type: Number,
    },
    maxTime: {
      type: Number,
    },
  },
  data() {
    return {
      component: DatePicker,
    }
  },
  methods: {
    handleChange(date) {
      /* If we use v-model then we don't need to
      handle this in parent. Visit below link for more info
      https://www.digitalocean.com/community/tutorials/how-to-add-v-model-support-to-custom-vue-js-components */
      this.$emit("input", date)
    },
  },
}
</script>
